export class MonthlyAuditCompletionRow {
    public MonthLabel: string = '';
    public TotalCompleted: number = 0;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
